import { render, staticRenderFns } from "./EmployeeRecognitionForm.vue?vue&type=template&id=3422ac88"
import script from "./EmployeeRecognitionForm.vue?vue&type=script&lang=js"
export * from "./EmployeeRecognitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports